module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/95ae02512eb2280da0b1eb0711ec948c.gif";